import apiClient from './api.client';
import type {
  OrgPublicProfile,
  OrgMembership,
  OrgSettings,
  EventAttendee,
} from '../types/public_event.types';

const BASE = (id: string) => `/orgs/${id}`;

export async function getMyOrgs(): Promise<OrgMembership[]> {
  const res = await apiClient.get<{ data: OrgMembership[] }>('/orgs/mine');
  return res.data.data;
}

export async function getOrgProfile(orgId: string): Promise<OrgPublicProfile> {
  const res = await apiClient.get<{ data: OrgPublicProfile }>(BASE(orgId));
  return res.data.data;
}

export async function joinOrg(orgId: string): Promise<OrgMembership> {
  const res = await apiClient.post<{ data: OrgMembership }>(`${BASE(orgId)}/join`);
  return res.data.data;
}

export async function leaveOrg(orgId: string): Promise<void> {
  await apiClient.delete(`${BASE(orgId)}/leave`);
}

export async function getOrgMembers(orgId: string): Promise<OrgMembership[]> {
  const res = await apiClient.get<{ data: OrgMembership[] }>(`${BASE(orgId)}/members`);
  return res.data.data;
}

export async function approveMember(orgId: string, userId: string): Promise<OrgMembership> {
  const res = await apiClient.post<{ data: OrgMembership }>(`${BASE(orgId)}/members/${userId}/approve`);
  return res.data.data;
}

export async function denyMember(orgId: string, userId: string): Promise<void> {
  await apiClient.post(`${BASE(orgId)}/members/${userId}/deny`);
}

export async function kickMember(orgId: string, userId: string): Promise<void> {
  await apiClient.delete(`${BASE(orgId)}/members/${userId}/kick`);
}

export async function banMember(orgId: string, userId: string): Promise<void> {
  await apiClient.post(`${BASE(orgId)}/members/${userId}/ban`);
}

export async function updateOrgSettings(orgId: string, settings: Partial<OrgSettings>): Promise<void> {
  await apiClient.patch(`${BASE(orgId)}/settings`, settings);
}

export async function attendEvent(eventId: string): Promise<EventAttendee> {
  const res = await apiClient.post<{ data: EventAttendee }>(`/public-events/${eventId}/attend`);
  return res.data.data;
}

export async function unattendEvent(eventId: string): Promise<void> {
  await apiClient.delete(`/public-events/${eventId}/attend`);
}

export async function getEventAttendees(eventId: string): Promise<EventAttendee[]> {
  const res = await apiClient.get<{ data: EventAttendee[] }>(`/public-events/${eventId}/attendees`);
  return res.data.data;
}
